module.exports = __webpack_public_path__ + "static/media/cocorobolixianban3.fc64eca4.png";